import Enumerable from "linq";
import { CheckListItemType } from "../../../components/check-list/CheckList";
import { customizationSettingsFieldIsDirty, mergeUICustomizationSettings, toUICustomizationSettingsField } from "../../../components/ui-customization-settings/UICustomizationSettingsUtils";
import { IUICustomizationPresetDTO } from "../../../services/ui-customization-data-service/Models";
import { UserAndRoleAdministrationUsers } from "../../../services/user-role-administration-service/Models";
import { RoleAssociatedUserFieldType } from "../../user-role-administration-view/role-administration/role-editor/RoleFieldTypes";
import { ICustomizationPresetAssociatedUserFieldIsDirtyType, UICustomizationPresetAssociatedUserFieldType, UICustomizationPresetFieldIsDirtyType, UICustomizationPresetFieldType } from "./UICustomizationPresetEditorFieldTypes";

export const NewPresetID = -1;

///////////////////////////////////////////////////////////////////////////////////////////////
// #region Validation Functions

export function generalIsValid(
    preset: UICustomizationPresetFieldType
): boolean {

    return (preset.name?.trim()?.length ?? 0) > 0 &&
        (preset.description?.trim()?.length ?? 0) > 0;
}

export function pageVisibilityIsValid(
    // preset: UICustomizationPresetFieldType
): boolean {
    return true;
}

export function membershipIsValid(
    // preset: UICustomizationPresetFieldType
): boolean {
    return true;
}

// #endregion Validation Functions

///////////////////////////////////////////////////////////////////////////////////////////////
// #region Merge Functions

// need to define base preset model type

export function mergePreset(
    presetModel: IUICustomizationPresetDTO,
    presetField: UICustomizationPresetFieldType
): IUICustomizationPresetDTO {

    const customizationSettingsJSON = JSON.stringify(mergeUICustomizationSettings(presetField.customizationSettings));

    const preset: IUICustomizationPresetDTO = {
        ...presetModel,
        id: presetField.id,
        name: presetField.name ?? "",
        description: presetField.description,
        settingsJSON: customizationSettingsJSON,
        userIDs: mergePresetUsers(presetField.users)
    };

    return preset;
}

function mergePresetUsers(
    userFields: Array<UICustomizationPresetAssociatedUserFieldType>
): Array<number> {
    return userFields.map(r => r.id);
}

// #endregion Merge Functions

///////////////////////////////////////////////////////////////////////////////////////////////
// #region Field conversion functions

export function toPresetField(
    dto: IUICustomizationPresetDTO
): UICustomizationPresetFieldType {

    const customizationSettings = dto.settingsJSON
        ? JSON.parse(dto.settingsJSON)
        : undefined;

    return {
        id: dto.id,
        name: dto.name,
        description: dto.description,
        customizationSettings: toUICustomizationSettingsField(customizationSettings),
        users: toUserFields(dto)
    };
}

function toUserFields(
    dto: IUICustomizationPresetDTO
): Array<UICustomizationPresetAssociatedUserFieldType> {
    return dto.userIDs?.map(id => {
        return {
            id: id
        };
    }) ?? [];
}

// #endregion Field conversion functions

///////////////////////////////////////////////////////////////////////////////////////////////
// #region Membership Step Functions

export function createAvailableUserCheckListItems(
    availableUsers: UserAndRoleAdministrationUsers | undefined,
    selectedUserFields: Array<RoleAssociatedUserFieldType>
): Array<CheckListItemType> {

    return Enumerable
        .from(availableUsers?.users ?? [])
        .select(user => {

            const columnIndex = selectedUserFields
                .findIndex(u => u.id === user.id);

            return {
                key: `${user.id}`,
                displayText: `${user.lastName}, ${user.firstName}`,
                secondaryText: user.login,
                tertiaryText: user.jobDescription,
                checked: columnIndex > -1,
                active: true,
                disabled: //(user.uiCustomizationPresetID ?? 0) > 0 ||
                    (user.uiCustomizationSettings?.length ?? 0) > 0
            } as CheckListItemType;
        })
        .orderBy(c => c.displayText.toUpperCase())
        .toArray();
}

// #endregion Membership Step Functions

///////////////////////////////////////////////////////////////////////////////////////////////
// #region IsDirty Functions

export function presetFieldIsDirty(dirtyFields?: UICustomizationPresetFieldIsDirtyType): boolean {
    return (
        dirtyFields?.id ||
        dirtyFields?.name ||
        dirtyFields?.description ||
        dirtyFields?.users?.some(r => userFieldIsDirty(r)) ||
        customizationSettingsFieldIsDirty(dirtyFields?.customizationSettings)
    ) ?? false;
}

function userFieldIsDirty(dirtyFields?: ICustomizationPresetAssociatedUserFieldIsDirtyType): boolean {
    return (
        dirtyFields?.id
    ) ?? false;
}

// #endregion IsDirty Functions

///////////////////////////////////////////////////////////////////////////////////////////////